import script from "./PsychogramManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PsychogramManager.vue?vue&type=script&setup=true&lang=js"

import "./PsychogramManager.vue?vue&type=style&index=0&id=1a23688d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a23688d"]])

export default __exports__